"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Event;
(function (Event) {
    Event["ClickSuggestion"] = "click-suggestion";
    Event["ClickItem"] = "click-item";
    Event["Redirect"] = "redirect";
    Event["Purchase"] = "purchase";
    Event["AddToCart"] = "add-to-cart";
    Event["UpdateCart"] = "update-cart";
    Event["ViewPage"] = "view-page";
})(Event = exports.Event || (exports.Event = {}));
//# sourceMappingURL=Feedback.js.map